
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.877 6.976c-.546-.24-1.43-.872-.8-1.143.214.01.417.037.492.08.147.084.328.048.404-.082.075-.13.017-.303-.131-.388-.218-.125-.565-.163-.836-.173-.128-.172-.1-.454-.1-.454L2.628 1.223 2.383.571l-.2.344L1.735.66.996 1.93l3.232 1.85c.49.281 1.119.96.814 1.642a.994.994 0 00-.096.134c-.369.633.031 1.549.891 2.041.492.282 1.03.365 1.469.266l.077-.02.002-.001c1.308-1.205 2.492-.867 2.492-.867zM6.896 4.2l1.27.728c.098.055.136.17.087.255-.05.085-.169.109-.266.053l-1.27-.728c-.098-.055-.136-.17-.087-.254.05-.085.169-.11.266-.054zm-.3.514l1.272.727c.097.056.135.17.086.255-.05.085-.169.109-.266.053l-1.27-.727c-.098-.056-.136-.17-.087-.255.05-.085.169-.109.266-.053zm-.453 2.36c-.522-.299-.796-.837-.599-1.175.197-.338.804-.371 1.326-.073.129.074.243.163.338.26-.26.17-.656.362-.886.26-.117-.05-.247-.008-.29.096-.04.097.01.212.11.27a.27.27 0 00.025.012c.455.2.998-.074 1.298-.268.084.196.093.39.003.545-.197.338-.804.371-1.325.073z"}}),_c('path',{attrs:{"d":"M9.865 7.236c-1.396-.36-2.379.807-2.379.807.454.323-.326 1.865-.326 1.865-.6.66.341 2.52 1.876 1.542 2.093-1.334 1.14-3.958.829-4.214z"}})])
          )
        }
      }
    